/**
 * /////////////////////////////////////////////////////////////////////////////
 *
 * https://keeptrack.space
 *
 * @Copyright (C) 2025 Kruczek Labs LLC
 *
 * KeepTrack is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * KeepTrack is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * KeepTrack. If not, see <http://www.gnu.org/licenses/>.
 *
 * /////////////////////////////////////////////////////////////////////////////
 */
import { SolarBody } from '@app/engine/core/interfaces';
import { settingsManager } from '../../../../settings/settings';
import { CelestialBody, PlanetColors } from './celestial-body';
export var MercuryTextureQuality;
(function (MercuryTextureQuality) {
    MercuryTextureQuality["POTATO"] = "512";
    MercuryTextureQuality["HIGH"] = "4k";
    MercuryTextureQuality["ULTRA"] = "8k";
})(MercuryTextureQuality || (MercuryTextureQuality = {}));
export class Mercury extends CelestialBody {
    RADIUS = 2439.7;
    NUM_HEIGHT_SEGS = 64;
    NUM_WIDTH_SEGS = 64;
    color = PlanetColors.MERCURY;
    orbitalPeriod = 0.2408467 * 365 * 24 * 3600;
    meanDistanceToSun = 57909227;
    eci;
    textureQuality = MercuryTextureQuality.POTATO;
    getTexturePath() {
        return `${settingsManager.installDirectory}textures/mercury${this.textureQuality}.jpg`;
    }
    getName() {
        return SolarBody.Mercury;
    }
    useHighestQualityTexture() {
        this.textureQuality = MercuryTextureQuality.ULTRA;
        this.loadTexture();
    }
    draw(sunPosition, tgtBuffer = null) {
        if (!this.isLoaded_ || settingsManager.isDisablePlanets) {
            return;
        }
        super.draw(sunPosition, tgtBuffer);
    }
}
